import {
    Button,
    Header,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';

const AddressModal = ({ invoice, open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <ModalHeader>
                {`Contactgegevens ${invoice?.customer?.name} ${invoice?.customer?.number}`}
            </ModalHeader>
            <ModalContent>
                {invoice?.customer?.invoice_email && (
                    <Header
                        as='h3'
                        subheader={invoice?.customer?.invoice_email}
                    >
                        Factuur e-mail:
                    </Header>
                )}

                <Header
                    as='h3'
                    subheader={
                        <>
                            <p>{invoice?.contact?.name}</p>
                            <p>{invoice?.contact?.email}</p>
                            <p>{invoice?.contact?.telephone_number}</p>
                            <p>{invoice?.contact?.mobile_number}</p>
                        </>
                    }
                >
                    Contactperson:
                </Header>

                {invoice?.address && (
                    <Header
                        as='h3'
                        subheader={
                            <>
                                <p>{`${invoice?.address?.street} ${invoice?.address?.house_number}`}</p>
                                <p>{`${invoice?.address?.zipcode} ${invoice?.address?.city}`}</p>
                            </>
                        }
                    >
                        Adres:
                    </Header>
                )}
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>Sluiten</Button>
            </ModalActions>
        </Modal>
    );
};

export default AddressModal;
